import React from 'react';
import { StudentIcon } from '../../../icons/inspector_icons';
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css';

export default function StudentCohortIconList(props) {
  return (
    <ul className={`abl-student-cohorts-list ${props.ratio}`}>
    {props.items.map((student, i) => {
      return (
        <li key={i} className={student.className}>
          <Tooltip 
            trigger={student.triggers} 
            placement="top" 
            mouseEnterDelay={0.25}
            mouseLeaveDelay={0.05} 
            overlay={student.name}
            align={{offset: [0, -10]}}>
            <span><StudentIcon /></span>
          </Tooltip>
        </li>
      );
    })}
    </ul>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule_inspector/student_cohort_icon_list.js
 **/